import React from "react";
import styled from "styled-components";
import { X, Plus } from "lucide-react";
import CustomInput from "./CustomInput";

const DomainsInput = ({ domains, onChange, onAdd, onRemove, placeholder = "example.com" }) => {
  return (
    <Container>
      <List>
        {domains.map((domain, index) => (
          <Row key={index}>
            <CustomInput
              value={domain}
              onChange={(e) => onChange(index, e.currentTarget.value)}
              placeholder={placeholder}
              className="border-0 shadow-none focus-visible:ring-0 px-0 bg-transparent"
            />
            {domains.length > 1 && (
              <RemoveButton onClick={() => onRemove(index)} title="Remove domain">
                <X size={15} />
              </RemoveButton>
            )}
          </Row>
        ))}
      </List>
      <AddRow onClick={onAdd}>
        <Plus size={15} />
        Add another domain
      </AddRow>
    </Container>
  );
};

export default DomainsInput;

const Container = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
`;

const List = styled.div`
  max-height: 220px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px 4px 12px;

  &:not(:last-child) {
    border-bottom: 1px solid #e5e7eb;
  }
`;

const RemoveButton = styled.button`
  flex-shrink: 0;
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: #f4ebff;
    color: #ef4444;
  }
`;

const AddRow = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f9fafb;
  border: none;
  border-top: 1px solid #e5e7eb;
  color: #7f56d9;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 12px;
  transition: background 0.15s;

  &:hover {
    background: #f4ebff;
  }
`;
